module.exports = __webpack_public_path__ + "img/phoneBGfafafb.3f55a529.png";